import { JDSInputCodeItemProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSInputCodeItemProps>
  ): React.FC<JDSInputCodeItemProps> =>
  (props: JDSInputCodeItemProps) => {
    return <Component {...props} />;
  };
